const baseURL = "/v1/Organograma";

const service = {
  methods: {
    $buscarOrganograma(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarOrganograma(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarOrganograma(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarOrganograma(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $gerenciarOrganograma(id) {
      return this.$api().get(`${baseURL}/${id}/Gerenciar`);
    },
    $obterSecretariasExecutivas(params) {
      return this.$api().get(`${baseURL}/SecretariaExecutiva`, params);
    },
    $inativarAtivarOrganograma(body, id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`, body);
    },
    $excluirOrganograma(body, id) {
      return this.$api().delete(`${baseURL}/${id}`, body);
    },
  },
};

export default service;
